<template>
  <div>
    <div class="flex">
      <div class="flex-grow-1">
        <DrugSearchNew ref="selectedDrug"/>
      </div>
      <button @click="addNewDrug" class="btn btn-default" type="button"><i class="icon-fa icon-fa-plus"/></button>
    </div>
    <hr>
    <div>
      <div class="flex mb-1 input-group" v-for="(d,i) in localSelectedDrugs" v-if="!d.to_delete">
        <input type="text" readonly :value="d.array_value.drug.title" class="form-control">
        <input type="number" v-model="d.array_value.rate" placeholder="Коэффициент" class="form-control">
        <div class="input-group-prepend">
          <div class="input-group-text"><input type="checkbox" v-model="d.array_value.useAsClientRequest"></div>
        </div>
        <input type="text" readonly value="учитывать при спросе" class="form-control">
        <button @click="removeDrug(d.array_value.drug.id)" class="btn btn-default" type="button"><i
          class="icon-fa icon-fa-remove"/>
        </button>
      </div>
    </div>
  </div>
</template>

<script>

import DrugSearchNew from "@/components/drugs/DrugSearchNew.vue";

export default {
  components: {DrugSearchNew},
  props: ['drugId', 'selectedDrugs', 'savedRecords'],
  data() {
    return {
      localSelectedDrugs: [],
    }
  },
  created() {
    if (this.savedRecords && this.savedRecords.length) {
      this.localSelectedDrugs = [...this.savedRecords]
    }
  },
  methods: {
    removeDrug(drugId) {
      const index = this.localSelectedDrugs.findIndex((d) => d.array_value.drug.id === +drugId);
      if (this.localSelectedDrugs[index].id) {
        this.localSelectedDrugs[index].to_delete = true;
      } else {
        this.localSelectedDrugs = this.localSelectedDrugs.filter((d) => d.array_value.drug.id !== +drugId);
      }
      this.localSelectedDrugs = [...this.localSelectedDrugs];
    },
    addNewDrug() {
      const newDrug = this.$refs.selectedDrug.drug;
      if (!newDrug?.id) return;
      if (newDrug.id === +this.drugId) return;
      if (this.localSelectedDrugs.find((d) => d.drug.id === newDrug.id)) return;
      this.localSelectedDrugs.push({
        group_alias: 'related_drug',
        alias: 'upload_to_catalog',
        type: 'int',
        value: newDrug.id,
        array_value: {drug: {id: newDrug.id, title: newDrug.title}}
      });
    },
    validate() {
      if (this.localSelectedDrugs.length) {
        if (this.localSelectedDrugs.find((d) => !d.array_value.rate || d.array_value.rate < 0)) {
          return {success: false, message: 'Коэффициенты для справочной указане не верно'}
        }
      }
      return {success: true, records: this.localSelectedDrugs};
    }
  }
}

</script>
